import { Component, OnInit } from '@angular/core';import { SettingsService } from './../settings.service';
import { ActivatedRoute,Router } from '@angular/router';
import { PatientsService } from '../patients.service';
import { Patient } from '../patients/patient';
import { AppointmentsService } from "./../appointments.service";
import { TranslateService } from '@ngx-translate/core';


@Component({
  standalone: false,
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {
  param
  GID
  isObgyn
  isCardio
  isGastro
  isEyes;
  hasSeparation;
  ID
  patient
  idAttemptsCounter=0;
  invalidId=false
  notFoundAWL=false
  processComplete=false
  constructor(private route: ActivatedRoute,private router: Router,private PatientsService:PatientsService,public SettingsService:SettingsService,public appointmentService: AppointmentsService,private translate: TranslateService ) { }
 
 
 
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.param = params['key']; 
      this.SettingsService.getClinic(this.param).subscribe(async(data:any)=>{
       if(data.error){
        return this.GID=null
       }
       this.GID=data.GID
       this.isCardio = data.isCardio ;
      this.isGastro=data.isGastro;
      this.isEyes=data.isEyes;
      this.isObgyn=(this.isCardio || this.isEyes || this.isGastro) ? false: true
      this.hasSeparation=data.hasSeparation
     
      
      }) 

    });
  }


  
  resetAll(){
  
  }


  
  async searchPatient(){
    this.invalidId=false
    if(!this.IDValidator()){
      this.idAttemptsCounter+=1
      return this.invalidId =true
    }
    this.notFoundAWL=false;
    this.processComplete=false;
  const todayAWL=await this.PatientsService.getTodayList(this.ID,this.GID);
  if(todayAWL['status']=='not found'){
    this.notFoundAWL=true
  }
  if(todayAWL['status']=='ok'){
    this.processComplete=true
  }
  }

  
  IDValidator()
  {
    
    let id:any = this.ID.replace('-','');
    if (id.length < 9 || isNaN(id)) {  // Make sure ID is formatted properly
          return false;
      }
      let sum = 0, incNum;
      for (let i=0; i < id.length; i++) {
          incNum = Number(id[i]) * ((i % 2) + 1);  // Multiply number by 1 or 2
          sum += (incNum > 9) ? incNum - 9 : incNum;  // Sum the digits up and add to total
      }
      return (sum % 10 === 0);
  }


}
